import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { locationsQuery } from '@queries';

import './ProjectRow.scss';

export const ProjectRow = ({ business }) => {
  // Fetch project locations
  const { data: locationsData, isPending: locationsIsPending } = useQuery(
    locationsQuery({
      business_id: business.id,
      published: 1,
      limit: 1,
    }),
  );

  return (
    <div className="sb-row-item">
      {/**<input type="checkbox" className="sb-row-item-check"></input>**/}
      <div className="sb-row--business-name">
        <p>
          <b>
            <Link to={`/dashboard/projects/${business.id}/sites`}>
              {business.business_name}
            </Link>
          </b>
        </p>
      </div>
      <div className="sb-row--business-location-count">
        {locationsIsPending && <p>...</p>}
        {!locationsIsPending && (
          <p>
            {locationsData.meta.total_count} location
            {locationsData.meta.total_count != 1 ? 's' : ''}
          </p>
        )}
      </div>
      <div className="sb-row--business-primary-domain">
        <p>{business.primary_domain}</p>
      </div>
      {/**<div className="sb-website-options sb-options">
        <button className="sb-website-options-menu-trigger sb-options-trigger"><MoreHorizontalIcon/></button>
      </div>**/}
    </div>
  );
};
